import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import components from '@/components' // 组件库导入
import '@/theme/index.scss' //
import '@/Tool/event'
import { getLang } from '@/services/apis/lang'
import vuex from '@/store'
import api from '@/services'
import { $t as lang } from '@/Tool'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $store: typeof store
    $ELEMENT: {
      size: string
      zIndex: number
    }
  }
}

// 获取语言包
getLang().then(async (result) => {
  vuex.commit('set_data', {
    langPackage: result.data,
  })
  const us = new URLSearchParams(window.location.search)
  const token = us.get('token')
  if (token) {
    localStorage.setItem('_localtoken', token)
    vuex.commit('set_data', {
      user: {
        token,
      },
    })
    const { data } = await api.Scrm_sys_api.srcmLogin.getUserInfo({
      error: false,
      success: false,
      data: { token },
    })
    const userInfo = {
      user: {
        token,
        info: data,
        orgid: data.corpId,
      },
    }
    vuex.commit('set_data', userInfo)
    sessionStorage.setItem('__user', JSON.stringify(userInfo))
  }

  window.name = 'MyVshow'
  document.title = lang('mainMenu.page.title')
  const app = createApp(App)
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
  // 组件库注册
  app.config.globalProperties.$ELEMENT = { size: 'small', zIndex: 2000 }
  components(app) // 全局组件注册
  app.config.globalProperties.$store = store
  app.use(router)
  app.use(store)
  app.mount('#main-frame-microservice')
})
